import { Link } from "react-router-dom";
import { Card } from "@/components/ui-helpers";
import { Flag, FolderKanban, CheckSquare } from "lucide-react";

const fmtDay = (v) => (v ? new Date(`${v.slice(0, 10)}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "");
const today = () => new Date().toISOString().slice(0, 10);

function Row({ to, icon: Icon, title, sub, right, rightClass, testid }) {
  return (
    <li>
      <Link to={to} data-testid={testid} className="flex items-center gap-3 py-2.5 px-1 rounded-lg hover:bg-rose-50/60 transition-colors">
        <div className="h-8 w-8 rounded-lg bg-rose-50 text-rose-600 flex items-center justify-center shrink-0"><Icon className="h-4 w-4" /></div>
        <div className="min-w-0 flex-1"><div className="text-sm font-semibold text-slate-800 truncate">{title}</div><div className="text-xs text-slate-500 truncate">{sub}</div></div>
        {right && <span className={`text-xs shrink-0 ${rightClass}`}>{right}</span>}
      </Link>
    </li>
  );
}

export function ImportantItemsCard({ cases = [], tasks = [] }) {
  return (
    <Card className="p-5 mt-4" data-testid="important-items-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-head font-bold text-slate-900 flex items-center gap-2"><Flag className="h-4 w-4 text-rose-600 fill-rose-600" /> Important</h3>
        <span className="text-xs text-slate-400" data-testid="important-items-count">{cases.length} cases · {tasks.length} tasks</span>
      </div>
      {cases.length + tasks.length === 0 ? (
        <div className="text-sm text-slate-400 py-4 text-center" data-testid="important-items-empty">Nothing flagged important right now.</div>
      ) : (
        <div className="grid lg:grid-cols-2 gap-x-6">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-1">Cases</div>
            {cases.length === 0 ? <div className="text-xs text-slate-400 py-2">No important cases</div> : (
              <ul className="divide-y divide-slate-100 max-h-72 overflow-y-auto">
                {cases.map((c) => <Row key={c.id} to={`/admin/applications/${c.id}`} icon={FolderKanban} title={`${c.client_name || "Client"} · ${c.service_type || "Case"}`} sub={c.current_stage || c.app_number} testid={`important-case-${c.id}`} />)}
              </ul>
            )}
          </div>
          <div>
            <div className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-1 mt-3 lg:mt-0">Tasks</div>
            {tasks.length === 0 ? <div className="text-xs text-slate-400 py-2">No important tasks</div> : (
              <ul className="divide-y divide-slate-100 max-h-72 overflow-y-auto">
                {tasks.map((t) => {
                  const overdue = t.due_date && t.due_date.slice(0, 10) < today();
                  return <Row key={t.id} to={t.application_id ? `/admin/applications/${t.application_id}?tab=tasks` : "/admin/tasks"} icon={CheckSquare} title={t.title}
                    sub={[t.client_name, t.case_label].filter(Boolean).join(" · ") || t.status} right={t.due_date ? `${overdue ? "Overdue · " : "Due "}${fmtDay(t.due_date)}` : ""}
                    rightClass={overdue ? "text-rose-600 font-semibold" : "text-slate-400"} testid={`important-task-${t.id}`} />;
                })}
              </ul>
            )}
          </div>
        </div>
      )}
    </Card>
  );
}
